import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useActionChoices } from "stores";
import { FormRadioGroupInput } from "form";

const ActionTypeInput = ({ isViewMode }) => {
  const { t } = useTranslation();
  const { actionTypes } = useActionChoices();

  const options = useMemo(
    () =>
      Object.values(actionTypes).map(({ id }) => ({
        value: id,
        label: t("ActionType.Action", { count: id }),
      })),
    [actionTypes, t],
  );

  return (
    <FormRadioGroupInput
      name="actionTypeId"
      isViewMode={isViewMode}
      options={options}
    />
  );
};

export default ActionTypeInput;
